module.exports = __webpack_public_path__ + "img/AstroFrens199.ed3d7a4c.jpg";